import { useState } from 'react';

type TopicTagsOverflowProps = {
  topics: string[];
  maxVisible?: number;
  moreLabel: (count: number) => string;
  classNameForTopic: (topic: string) => string;
  className?: string;
  moreButtonClassName?: string;
  popoverClassName?: string;
};

export function TopicTagsOverflow({
  topics,
  maxVisible = 2,
  moreLabel,
  classNameForTopic,
  className = 'relative min-w-0 max-w-[14rem]',
  moreButtonClassName = 'shrink-0 text-[11px] font-medium px-2 py-0.5 rounded-full border border-slate-200 bg-slate-50 text-slate-600 hover:bg-slate-100 hover:border-slate-300 transition-colors',
  popoverClassName = 'absolute left-0 top-[calc(100%+4px)] z-30 min-w-[10rem] max-w-[15rem] rounded-lg border border-slate-200 bg-white p-2 shadow-lg',
}: TopicTagsOverflowProps) {
  const [open, setOpen] = useState(false);
  const visible = topics.slice(0, maxVisible);
  const hiddenCount = Math.max(0, topics.length - maxVisible);
  const hasOverflow = hiddenCount > 0;

  return (
    <div className={className}>
      <div className="flex items-center gap-1 min-w-0">
        {visible.map((topic) => (
          <span key={topic} className={classNameForTopic(topic)} title={topic}>
            {topic}
          </span>
        ))}
        {hasOverflow ? (
          <button
            type="button"
            className={moreButtonClassName}
            aria-expanded={open}
            aria-label={moreLabel(hiddenCount)}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
            onClick={() => setOpen((prev) => !prev)}
          >
            {moreLabel(hiddenCount)}
          </button>
        ) : null}
      </div>
      {open && hasOverflow ? (
        <div
          className={popoverClassName}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          <div className="flex flex-wrap gap-1">
            {topics.map((topic) => (
              <span key={`all-${topic}`} className={classNameForTopic(topic)} title={topic}>
                {topic}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
